<script lang="ts">
  import { Router, Route } from 'svelte-routing';
  import { get } from 'svelte/store';
  import {
    authStore,
    initAuth,
    signInWithEmail,
    createAccountWithEmail,
    signOut,
    register,
  } from '$lib/stores/auth';
  import Landing from './routes/Landing.svelte';
  import UserPage from './routes/UserPage.svelte';
  import OgpPage from './routes/OgpPage.svelte';
  import NotFound from './routes/NotFound.svelte';
  import { onMount } from 'svelte';

  // Initialize auth on mount
  onMount(() => {
    initAuth();

    // Expose auth helpers for E2E testing (check both string and boolean)
    const useEmulator = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR === 'true' ||
                        import.meta.env.VITE_FIREBASE_AUTH_EMULATOR === true ||
                        import.meta.env.MODE === 'test';

    if (useEmulator) {
      (window as any).__authStore = {
        get initialized() {
          return get(authStore).initialized;
        },
        get user() {
          return get(authStore).user;
        },
        get firebaseUser() {
          return get(authStore).firebaseUser;
        },
        get loading() {
          return get(authStore).loading;
        },
      };
      (window as any).__authHelpers = {
        signInWithEmail,
        createAccountWithEmail,
        signOut,
        register,
      };
    }
  });
</script>

<Router>
  <main class="min-h-screen">
    <Route path="/" component={Landing} />
    <Route path="/_ogp/:username" let:params>
      <OgpPage params={{ username: params.username }} />
    </Route>
    <Route path="/:username" let:params>
      <UserPage params={{ username: params.username }} />
    </Route>
  </main>
</Router>
